
//  export const BaseURL = `https://etaxiapi.rayantaxi.com/`;
// export const BaseURL = `https://etaxi.Point.net/`;
export const BaseURL = `https://hijabi-back-dev.point-dev.net/api/`;
export const ImageBaseURL = `https://hijabi-back-dev.point-dev.net`;


// export const BaseURL = `http://192.168.1.14:8000/`;
export const BaseURL_IMAGE = BaseURL.slice(0,-1);


const PROJECT_NAME = "Hijab"

export const TOKEN_KEY = PROJECT_NAME +  "_TOKEN"

export const USER_KEY =  PROJECT_NAME + "_USER"

